<template>
  <div class="card">
    <h6>SUPPLIER CONSENTS</h6>

    <supplier-specific-terms-eon :v="$v" v-if="supplierId == 4"></supplier-specific-terms-eon>
    <supplier-specific-terms-eon-next :v="$v" v-else-if="supplierId == 111"></supplier-specific-terms-eon-next>
    <supplier-specific-terms-edf :v="$v" v-else-if="supplierId == 7"></supplier-specific-terms-edf>
    <supplier-specific-terms-shell-energy :v="$v" v-else-if="supplierId == 8"></supplier-specific-terms-shell-energy>
    <supplier-specific-terms-ovo :v="$v" v-else-if="supplierId == 12"></supplier-specific-terms-ovo>
    <supplier-specific-terms-utilita :v="$v" v-else-if="supplierId == 22"></supplier-specific-terms-utilita>
    <supplier-specific-terms-pfp-energy :v="$v" v-else-if="supplierId == 42"></supplier-specific-terms-pfp-energy>
    <supplier-specific-terms-octopus-energy :v="$v" v-else-if="supplierId == 49"></supplier-specific-terms-octopus-energy>
    <supplier-specific-terms-so-energy :v="$v" v-else-if="supplierId == 43"></supplier-specific-terms-so-energy>
    <supplier-specific-terms-rebel-energy :v="$v" v-else-if="supplierId == 116"></supplier-specific-terms-rebel-energy>

    <supplier-specific-terms-default :v="$v" v-else></supplier-specific-terms-default>
  </div>
</template>

<script>
import SupplierSpecificTerms from '../../../../base/components/supplier-specific-terms';

import { mapState } from 'vuex';

export default {
  name: 'SupplierTerms',
  props: {
    $form: Object,
    $v: Object
  },
  computed: {
    ...mapState({
      supplierId: ({ personal_details_switch_plan }) => personal_details_switch_plan.supplierId,
      terms: ({ personal_details_terms }) => personal_details_terms,
      specialNeedsList: ({ lookups }) => lookups.specialNeeds
    })
  },
  methods: {
    onChangeSpecialNeeds () {
      if (this.terms.hasMedicalConditionOrIndividualRequirement) {
        this.$store.dispatch('lookups/getSpecialNeedsList');
      } else {
        this.terms.specialNeedsId = null;
      }
    }
  },
  components: {
    ...SupplierSpecificTerms
  }
};
</script>

<style lang="scss"></style>
